/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".heading[_ngcontent-%COMP%]{color:#495057;margin:0 0 20px;font-size:1.5rem;font-weight:400;line-height:2.5rem}\n/*# sourceMappingURL=captain-fraud-orders.component.css.map*/"];
export { styles as styles };
